import {
  enableProdMode,
  NgZone,
  provideZoneChangeDetection,
} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { installE2eTestHooks } from './app/testing/e2e-test-hooks';
import { environment } from './environments/environment';
import { UIRouter, UrlService } from '@uirouter/core';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .then((platformRef) => {
    const urlService: UrlService =
      platformRef.injector.get(UIRouter).urlService;
    platformRef.injector.get<NgZone>(NgZone).run(() => {
      urlService.listen();
      urlService.sync();
    });

    // Installs app-side hooks for end-to-end tests. Never exposed in prod/beta,
    // which set `production: true`.
    if (!environment.production) {
      installE2eTestHooks(platformRef.injector);
    }
  })
  .catch((err) => console.log(err));
